import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { useUser } from '@dofleini/security';
import { partner } from '@mep/pae-commons';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import BooleanPreview from '@/components/BooleanPreview';
import VerifyListItem
  from '@/modules/proposalRequest/components/ProposalCreateForm/ProposalVerifyData/components/VerifyListItem';
import { showPrice } from '@/utils/utils';

import style from './index.less';

const { CIVIL_STATUS } = partner;

const GoodItem = ({ data, onEdit, onDelete, onlyRead, owner, hideCommunityProperty }) => {
  const { t } = useTranslation('proposalRequest');
  const { user } = useUser();
  
  const isMarried = useMemo(() => !hideCommunityProperty && (owner || user)?.civilStatus === CIVIL_STATUS.MARRIED, [hideCommunityProperty, owner, user]);
  
  const { name, monetaryValuation, isCommon, isRight } = data || {};
  
  return (
    <div className="bg-secondary text-white rounded px-4 py-2 pt-4 mb-2 flex items-center justify-between">
      <div className="w-full mr-8">
        <VerifyListItem labelKey={t('proposalRequest.form.partners.goods.name.placeholder')} fullView>
          {name}
        </VerifyListItem>
        <div className={classNames('w-full flex items-center gap-x-4', { 'justify-between': isMarried })}>
          <VerifyListItem labelKey={t('proposalRequest.form.partners.goods.monetaryValuation.placeholder')} fullView>
            {showPrice(monetaryValuation)}
          </VerifyListItem>
          {isMarried &&
          <VerifyListItem labelKey={t('proposalRequest.form.partners.goods.isMatrimonialCommunity.title')} fullView>
            <BooleanPreview value={isCommon}/>
          </VerifyListItem>}
          <VerifyListItem labelKey={t('proposalRequest.form.partners.goods.isRight.title')} fullView>
            <BooleanPreview value={isRight}/>
          </VerifyListItem>
        </div>
      </div>
      {!onlyRead &&
      <div className={classNames(style.actionContainer, 'border border-solid pl-4 border-r-0 border-t-0 border-b-0')}>
        <div className="h-full min-w-8 min-h-12 flex flex-col justify-center items-center">
          <div className="flex flex-1 items-center cursor-pointer" onClick={onEdit}><EditOutlined/></div>
          <div className="flex flex-1 items-center cursor-pointer" onClick={onDelete}><DeleteOutlined/></div>
        </div>
      </div>}
    </div>
  );
};

GoodItem.propTypes = {
  data: PropTypes.object,
  owner: PropTypes.object,
  onlyRead: PropTypes.bool,
  hideCommunityProperty: PropTypes.bool,
  onDelete: PropTypes.func,
  onEdit: PropTypes.func
};

GoodItem.defaultProps = {};

export default memo(GoodItem);
